import React from 'react';
import WebModal from './Modal';
import { useTranslation } from 'react-i18next';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import Button from '@material-ui/core/Button';
import { isMobile } from '@/biz/tool';
import { formattedDate } from '@/biz/time';

interface Props {}

const ModalPublishTime: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const { showModalPublishTime, setShowModalPublishTime } = useWebModalStore();

  return (
    <>
      <WebModal
        width={isMobile() ? 380 : 570}
        visible={showModalPublishTime}
        handleClose={() => {
          setShowModalPublishTime(false);
        }}
        isShowFooter={false}
      >
        <div className="w-full ">
          <div className="self-stretch text-center justify-start text-text-color-primary text-xl font-semibold leading-loose">
            {t('modal.publish_time.title', {
              defaultValue: 'Congratulations!'
            })}
          </div>
          <div className="mb-5 justify-start text-center text-base font-medium leading-normal">
            {t('modal.publish_time.content', {
              defaultValue: 'Your content draft was approved by the brand.'
            })}
          </div>
          <div className="w-full self-stretch px-6 pt-6 pb-8 bg-[#F5F5F4] rounded-2xl inline-flex flex-col justify-start items-start gap-2">
            <div className="justify-start text-font&icon-primary text-base font-medium leading-normal">
              {t('modal.publish_time.content_title', {
                defaultValue: 'Next step: Publish the content'
              })}
            </div>
            <div
              className="text-[#60646C] text-sm "
              dangerouslySetInnerHTML={{
                __html: t('modal.publish_time.content_desc', {
                  defaultValue:
                    'The brand has <span class="text-[#5A31F0]">updated the content publish deadline.</span> Please make sure to submit your content within the required timeframe.'
                })
              }}
            ></div>
            {detailData?.order?.postTimeRange?.length > 0 && (
              <div className="text-[#5A31F0] mt-4 self-stretch text-center text-2xl font-semibold leading-9">
                {formattedDate(detailData?.order?.postTimeRange?.[0])} -{' '}
                {formattedDate(detailData?.order?.postTimeRange?.[1])}
              </div>
            )}
          </div>
          <div className="mt-8 flex justify-center">
            <Button
              className="w-[368px] !bg-[#5B3DE9] !text-[#fff]"
              variant="contained"
              onClick={() => setShowModalPublishTime(false)}
            >
              {t('modal.publish_time.btn_content', { defaultValue: 'Confirm' })}
            </Button>
          </div>
        </div>
      </WebModal>
    </>
  );
};

export default ModalPublishTime;
